<template>
  <a :href="url">
    <img :src="inseegoLogoSvg.src" width="102" alt="Inseego">
  </a>
</template>

<script setup>
import inseegoLogoSvg from '~/assets/inseego-logo.svg'
const { url } = defineProps({ url: String })
</script>
